import React from 'react'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'

import { StyledButtonWrapper, StyledForm, StyledTextField } from './elements'
import { CreateRoleRequestPayload } from '../../api/roles/models'
import {
  ERROR_NOTIFICATION_OPTIONS,
  SUCCESS_NOTIFICATION_OPTIONS,
} from '../../configs/constants'
import { createRoleAction } from '../../store/slices/roles/actions'

interface RoleCreateFormProps {
  postSubmitActionHandler: () => void
}

type FormValues = CreateRoleRequestPayload

/** intital form value */
const INITIAL_FORM_VALUE: FormValues = {
  name: '',
  description: '',
}

const RoleCreateForm: React.FC<RoleCreateFormProps> = ({
  postSubmitActionHandler,
}): JSX.Element => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const formik = useFormik<FormValues>({
    initialValues: INITIAL_FORM_VALUE,
    onSubmit: (values: FormValues) => {
      dispatch(
        createRoleAction({
          ...values,
          postSuccessHandler: () => {
            enqueueSnackbar(
              'Access group created successfully!',
              SUCCESS_NOTIFICATION_OPTIONS
            )
            postSubmitActionHandler()
          },
          errorHandler: () => {
            enqueueSnackbar(
              'Failed to create access group!',
              ERROR_NOTIFICATION_OPTIONS
            )
          },
        })
      )
    },
  })

  return (
    <div>
      <StyledForm onSubmit={formik.handleSubmit}>
        <StyledTextField
          id="name"
          name="name"
          label="Name"
          margin="normal"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />
        <StyledTextField
          id="description"
          name="description"
          label="Description"
          margin="normal"
          value={formik.values.description}
          onChange={formik.handleChange}
          error={
            formik.touched.description && Boolean(formik.errors.description)
          }
          helperText={formik.touched.description && formik.errors.description}
        />
        <StyledButtonWrapper>
          <Button color="secondary" variant="contained" type="submit">
            Create Access Group
          </Button>
        </StyledButtonWrapper>
      </StyledForm>
    </div>
  )
}

export default RoleCreateForm
